// extracted by mini-css-extract-plugin
export default {"OnboardingProcessFooter":"mr7innBo87W6cu3bYDX4","CompanyName":"K_FS64wdpHqbwD90DrMZ","ChatbotName":"i4I9lnkatZ2JPXRwWcNM"};